import { render, staticRenderFns } from "./ListRequestInven.vue?vue&type=template&id=f997a4dc&"
import script from "./ListRequestInven.vue?vue&type=script&lang=js&"
export * from "./ListRequestInven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports